module.exports = __webpack_public_path__ + "img/all-inclusive.92eccd10.svg";